import { ArrayDataSource } from './BaseDataSources';
import { IPriceSubType } from '../Interfaces';

export class PriceSubTypeSource extends ArrayDataSource<IPriceSubType> {
  public constructor() {
    super('/datasource/pricesubtypes');
  }
}